function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.881 16.244h8.238",
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 10,
  r: 1,
  fill: "#243143",
  fillOpacity: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 10,
  r: 1.25,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 10,
  r: 1,
  fill: "#243143",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 10,
  r: 1.25,
  stroke: "#243143",
  strokeOpacity: 0.6,
  strokeWidth: 0.5,
  strokeLinecap: "round"
});

function SvgNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTAiIHN0cm9rZT0iIzI0MzE0MyIgc3Ryb2tlLW9wYWNpdHk9IjAuNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuODgxMzUgMTYuMjQ0MUg5LjVIMTIuMDMwNEgxNC4xNTc0SDE2LjExODkiIHN0cm9rZT0iIzI0MzE0MyIgc3Ryb2tlLW9wYWNpdHk9IjAuNiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iOSIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMjQzMTQzIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iMTAiIHI9IjEuMjUiIHN0cm9rZT0iIzI0MzE0MyIgc3Ryb2tlLW9wYWNpdHk9IjAuNiIgc3Ryb2tlLXdpZHRoPSIwLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMjQzMTQzIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjEwIiByPSIxLjI1IiBzdHJva2U9IiMyNDMxNDMiIHN0cm9rZS1vcGFjaXR5PSIwLjYiIHN0cm9rZS13aWR0aD0iMC41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgNeutral as ReactComponent };